import SettingsActionItem from './SettingsActionItem';

class SettingsComponentItem extends SettingsActionItem {
  public component?: any;
  public props?: any;
}

export default SettingsComponentItem;